<div class="PGLoading text-muted {{hasError ? 'PGLoading--Error' : ''}} {{isSmall ? 'PGLoading--Small' : ''}} {{isLarge ? 'PGLoading--Large' : ''}} {{isOverlay ? 'PGLoading--Overlay' : ''}} {{isFullscreen ? 'PGLoading--Fullscreen' : ''}}"
    role="status"
    [attr.aria-live]="hasError ? 'assertive' : 'polite'"
    [attr.aria-busy]="!hasError"
    [attr.aria-label]="(hasError ? 'pg-loading.error' : 'pg-loading.loading') | locTranslate">
    <span class="visually-hidden">{{ (hasError ? 'pg-loading.error' : 'pg-loading.loading') | locTranslate }}@if (hasProgressBar()) { ({{ getProgressPercent() }}%) }</span>
    <span aria-hidden="true">
        <div class="pg-animation-fadein">
            @if (isLarge) {
                <div class="PGMultiSpin">
                    <div>
                        <div>
                            <div>
                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            @if (!isLarge) {
                <i class="PGLoading-Icon fa-regular fa-circle-notch pg-animation-spin"></i>
            }
            @if (hasProgressBar()) {
                <span>
                    <div class="PGLoading-Progress" [ngClass]="{ 'pg-animation-shake': hasError }">
                        <div class="progress" role="progressbar" [attr.aria-valuemin]="0" [attr.aria-valuemax]="100" [attr.aria-valuenow]="getProgressPercent()">
                            <div class="progress-bar" class="bg-{{ hasError ? 'danger' : getProgressRatio() < 1 ? 'primary' : 'success' }}" [style.transform]="'scale(' + getProgressRatio() + ', 1)'"></div>
                        </div>
                    </div>
                </span>
            }
        </div>
    </span>
    @if (hasError) {
        <span aria-hidden="true">
            <div class="pg-animation-shake" class="text-danger">
                <i class="fa-regular fa-exclamation-triangle"></i>
            </div>
        </span>
    }
</div>
